export default {
      id: "fleche_droite-usage",
      viewBox: "0 0 70 69",
      url: "../dist/images/" + "sprite.svg#fleche_droite-usage",
      toString: function () {
        return this.url;
      }
    }